import {useState,useEffect,useContext} from 'react';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {BiSearchAlt} from 'react-icons/bi';
import {HiOutlineDocumentSearch} from 'react-icons/hi';
import { Card,CardBody,CardHeader, List } from 'reactstrap';
import {Tabs,Tab,Typography,Box,TextField,Button,IconButton} from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ProyectoBusqueda } from '../interfaces/ProyectoBusqueda';
import {format} from 'date-fns';
import BusqProyTable from './Proyectos/BusqProyTable';
import { DataBsqProy } from '../interfaces/DataBsqProy';
import { CasUserContext } from '../services/casUserContext';
import { AdaptiveSelect } from './Common/AdaptiveSelect';
import ProyectoService from '../services/ProyectoService';
import { Option } from '../interfaces/ProyectosDTOS/Option';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const proyectoService = new ProyectoService();

export function BusquedaProyectos() {
 const {id} = useParams();   
 const localBack : string = process.env.REACT_APP_BACK || '';
 const[data,setData] = useState<Array<ProyectoBusqueda>>([]);
 const[tab,setTab] = useState(0);
 const[usuario,setUsuario] = useState('');
 const[titulo,setTitulo] = useState('');
 const[codigo,setCodigo] = useState('');
 const casUserContext = useContext(CasUserContext);
 const token = casUserContext.token;
//#region Interactive
 const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  setTab(newValue);
 };
 //#endregion
 //#region Funciones
 const fillOptionsUsuario = async (searchTerm: string) =>{
  try {
    const data = await proyectoService.GetProyectosEnviadosByUser(searchTerm, token);
    if (data.status.isSuccessfully) {
      return data.listData;                      
    } else {
      return [];
    }
  } catch (error) {
    console.error(error);
    return [];
  }
};
const fillOptionsTitulos = async (searchTerm: string) =>{
  try {
    const data = await proyectoService.GetProyectosEnviadosByTitulo(searchTerm, token);
    if (data.status.isSuccessfully) {
      return data.listData;                      
    } else {
      return [];
    }
  } catch (error) {
    console.error(error);
    return [];
  }
};
const fillOptionsCodigos = async (searchTerm: string) =>{
  try {
    const data = await proyectoService.GetProyectoEnviadosByCodigo(searchTerm, token);
    if (data.status.isSuccessfully) {
      return data.listData;                      
    } else {
      return [];
    }
  } catch (error) {
    console.error(error);
    return [];
  }
};
 const handleUsuarioSearch = async () =>{
  try{
    const response = await axios.get(localBack+'/api/Proyecto/GetProyectosByUsuario/'+usuario,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    setData(response.data.listData);
    {/*console.log(data)*/}
  }catch(error){
    console.error('Error:',error);
  }
 };

 const handleTituloSearch = async (titulo: string) =>{
  try {
    const data = await proyectoService.GetProyectosByTitulo(titulo, token);
    if (data.status.isSuccessfully) {
      setData(data.listData);                     
    } else {
      console.log(data.status.messages);
    }
  } catch (error) {
    console.error(error);
  }
 };

 const handleCodigoSearch = async (codigo: string) => {
  try {
    const data = await proyectoService.GetProyectosByCodigo(codigo, token);
    if (data.status.isSuccessfully) {
      setData(data.listData);                     
    } else {
      console.log(data.status.messages);
    }
  } catch (error) {
    console.error(error);
  }
};
 const handleResponseCodigo = (selectedValue: Option) => {
  // Aquí puedes decidir qué hacer con el valor seleccionado
  // Por ejemplo, podrías establecerlo en la variable 'codigo'
  setCodigo(selectedValue.label);
  handleCodigoSearch(selectedValue.label);
};
const handleResponseTitulo = (selectedValue: Option) => {
  // Aquí puedes decidir qué hacer con el valor seleccionado
  // Por ejemplo, podrías establecerlo en la variable 'codigo'
  setTitulo(selectedValue.label);
  handleTituloSearch(selectedValue.label);
};
const handleResponseUsuario = (selectedValue: Option) => {
  // Aquí puedes decidir qué hacer con el valor seleccionado
  // Por ejemplo, podrías establecerlo en la variable 'codigo'
  //console.log(selectedValue);
  setUsuario(selectedValue.value.toString());
  // handleCodigoSearch(selectedValue.label);
};
 //#endregion
 
  return (
      <Card>
      <CardHeader>Búsqueda/Gestión de Proyectos</CardHeader>
      <CardBody>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Usuario" {...a11yProps(0)} />
          <Tab label="Proyecto" {...a11yProps(1)} />
          <Tab label="Código" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <Box
        component="form"
        sx={{
          '& > :not(style)': { m: 1 },
        }}
        noValidate
        autoComplete="off">
          <TextField
            required            
            id="outlined-required"
            label="Usuario"
            sx={{ m: 1, width: '100ch' }}
            size="small"
            value={usuario}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUsuario(event.target.value);
            }}
          />
          <Button size="large" variant="contained" endIcon={<BiSearchAlt />} onClick={() => {handleUsuarioSearch()}}>Buscar</Button>
        </Box>      
      </TabPanel>
      <TabPanel value={tab} index={1}>
      <Box
        component="form"
        sx={{
          '& > :not(style)': { m: 1 },
        }}
        noValidate
        autoComplete="off">
          <AdaptiveSelect 
            fillOptions={fillOptionsTitulos}
            onResponse={handleResponseTitulo}
          />
        </Box> 
      </TabPanel>
      <TabPanel value={tab} index={2}>
      <Box
        style={{ zIndex: 1000 }}
        component="form"
        sx={{'& > :not(style)': { m: 1 }, }}
        noValidate
        autoComplete="off">
          <AdaptiveSelect 
            fillOptions={fillOptionsCodigos} 
            onResponse={handleResponseCodigo}
          />
      </Box> 
      </TabPanel>
      </Box>
      <Box>
        <BusqProyTable rowsPerPage={[5 ,10, 25, 100]} data={data} />
      </Box>
    </CardBody>
   </Card>
  )
}
